import React, { useState, Suspense, lazy } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import RedirectToBlogs from "../components/RedirectToBlogs";
import SearchWidget2 from "../components/SearchWidget2";

// Lazy loaded components
const MainFullBlog = lazy(() => import("../components/MainFullBlog"));

const BlogsFilterSearch = lazy(() => import("../components/BlogsFilterSearch"));
const SocialShare = lazy(() => import("../components/SocialShare"));
const Comments = lazy(() => import("../components/Comments"));
const RandomQuote = lazy(() => import("../components/RandomQuote"));

const Blog = () => {
  const { urlHeading } = useParams();
  const [isError, setIsError] = useState(null);
  const [commentCount, setCommentCount] = useState(0);

  // Fallback component to show while lazy components load.
  const Loader = () => (
    <div className="text-center">
      <p>Loading...</p>
    </div>
  );

  return (
    <>
      {isError !== null &&
        (isError === 404 ? (
          <>
            <Breadcrumb name="Blog Not Found" />
            <RedirectToBlogs />
          </>
        ) : isError !== 200 && isError !== 201 ? (
          <>
            <Breadcrumb name="Something Went Wrong" />
            <RedirectToBlogs />
          </>
        ) : null)}

<SearchWidget2/>
      <section className="blog pt-110 pb-130">
        <div className="container">
          <div className="row mt-none-30">
            <div className="col-lg-8 mt-30">
              <div className="blog-post-wrapper">
                {isError !== null &&
                  (isError === 404 || (isError !== 200 && isError !== 201)) && (
                    <Suspense fallback={<Loader />}>
                      <RandomQuote />
                    </Suspense>
                  )}

                {(isError === null ||
                  isError === 200 ||
                  isError === 201) && (
                  <>
                    <Suspense fallback={<Loader />}>
                      <MainFullBlog
                        urlHeading={urlHeading}
                        setIsError={setIsError}
                        commentCount={commentCount}
                      />
                    </Suspense>
                    <div className="post-footer mt-10 mb-40 ul_li_between">
                      <Suspense fallback={<Loader />}>
                        <SocialShare urlHeading={urlHeading} />
                      </Suspense>
                    </div>
                    <Suspense fallback={<Loader />}>
                      <Comments setCommentCount={setCommentCount} urlHeading={urlHeading} />
                    </Suspense>
                  </>
                )}
              </div>
            </div>
           
              <Suspense fallback={<Loader />}>
                <BlogsFilterSearch />
              </Suspense>
            
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
